import {Injectable} from '@angular/core';
import {DEFAULT_LOCALE_GROUP, LOCALE_COOKIE_KEY} from "../ni-constants";
import {CookieService} from "ngx-cookie-service";

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor(private cookieService: CookieService) {
  }

  getCurrentLocale() {
    return this.cookieService.get(LOCALE_COOKIE_KEY) || DEFAULT_LOCALE_GROUP;
  }
}
